// 明細編集パネル
<template>
  <div class="cx_listFiles">
    <!-- <div> -->
      <div class="cx_listFiles_list">
        <!-- 左側の明細リスト 追加ボタンを配置-->
        <div class="cx_listFiles_header">
          <div class="cx_listFiles_caption">{{ $translate(title) }}</div>
          <div class="cx_listFiles_list_buttons">
            <Button @click="onUpload" caption="ファイル追加" icon="add" :disabled="enabled == false || parentId == 0 || (editor && editor.owner && $api.perms.hasMenuPermission(editor.owner.perm + '.file') == false)"  />
            <Button @click="onDelete" ref="delete" caption="ファイル削除" icon="delete" :disabled="items == undefined || items.length == 0 || enabled == false ||  (editor && editor.owner && $api.perms.hasMenuPermission(editor.owner.perm + '.file') == false) || electronicBookMode == true" />
          </div>
        </div>
        <!-- ファイルアップロード画面 -->
        <b-modal v-model="showUpload" title="ファイルアップロード" @ok="onAdd" :no-close-on-backdrop="true" centered v-if="showUpload">
          <input type="file" id="filename" name="files" ref="file" size="100" multiple="multiple" />
          <TextBox title="備考" :isEdit="true" :value.sync="description" :required="false" ref="description" v-if="showUpload" style="margin-top:10px;"/>
          <TextBox title="画像タグ" :isEdit="true" :value.sync="tag" :required="false" ref="tag" v-if="showUpload" style="margin-top:10px;" tooltip="商品、ユーザーの画像タグを帳票のプロパティ名と合わせることで、画像を帳票に出力できます。" />
        </b-modal>
        <!-- 備考編集画面 -->
        <b-modal v-model="showDescription" title="備考編集" @ok="onEdit" :no-close-on-backdrop="true" centered>
          <TextBox title="備考" :isEdit="true" :value.sync="description" :required="false" ref="description" v-if="showDescription" />
          <TextBox title="画像タグ" :isEdit="true" :value.sync="tag" :required="false" ref="tag" v-if="showDescription" tooltip="商品、ユーザーの画像タグを帳票のプロパティ名と合わせることで、画像を帳票に出力できます。"  />          
        </b-modal>
        <Grid storageKey="listFiles" :items="items" :captions="['ファイル名','更新日時','サイズ','担当者','アップロード日時','タグ','備考']" :widths="[250,150,120,120,150,100,150]" 
        :isLoading="isLoading" @selected="onSelected" ref="listBox" :showCheckBox="true">  
          <GridItem slot="col0" slot-scope="{item,index}"><a @click.prevent="onDownload(index)" href="javascript:void(0)">{{item.fileName}}</a></GridItem>
          <GridItem slot="col1" slot-scope="{item}">{{item.fileTimeStamp | timestamp}}</GridItem>
          <GridItem slot="col2" slot-scope="{item}">{{item.fileSizeKB | numeric(0)}}KB</GridItem>
          <GridItem slot="col3" slot-scope="{item}"><BadgeUser :value="item.uploadPIC" list="userGroup" />&nbsp;&nbsp;{{ item.uploadPIC | userGroup }}</GridItem>
          <GridItem slot="col4" slot-scope="{item}">{{item.uploadTimeStamp | timestamp}}</GridItem>
          <GridItem slot="col5" slot-scope="{item}">{{item.tag }}</GridItem>          
          <GridItem slot="col6" slot-scope="{item,index}">
            <div class="cx_listFiles_detail">
              <Button @click="onDescription(index)" caption="編集" v-if="enabled"/>{{item.description}}
            </div>
          </GridItem>    
        </Grid>
        <!-- <ListBox :items="items" :isLoading="isLoading" @selected="onSelected" ref="listBox" :showCheckBox="false" :height="height">
          <template slot="card" slot-scope="{ listBox, index, item }">
            <Card :listBox="listBox" :index="index">
              <CardColumn cols="6">
                <GridItem><router-link @click.native="onDownload(index)" to="">{{item.fileName}}</router-link></GridItem>
                <GridItem>更新日時：{{item.fileTimeStamp | timestamp}}</GridItem>
                <GridItem>サイズ：{{item.fileSize}}Byte</GridItem>
              </CardColumn>
              <CardColumn cols="6">
                <GridItem><BadgeUser :value="item.uploadPIC" list="userGroup" />&nbsp;&nbsp;{{ item.uploadPIC | userGroup }}</GridItem>
                <GridItem>アップロード日時：{{item.uploadTimeStamp | timestamp}}</GridItem>
                <GridItem>
                  <div class="cx_listFiles_detail">
                    <Button @click="onDescription(index)" caption="備考編集" />{{item.description}}
                  </div>
                </GridItem>
              </CardColumn>
            </Card>
          </template>
        </ListBox> -->
      </div>
    <!-- </div> -->
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class ListFiles extends Vue {
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: '' }) public title: string;
  @Prop({ default: 200 }) public height: number;
  @Prop({ default: false }) public electronicBookMode: boolean;

  @Prop({ default: null }) public parentKey: string; //伝票区分
  @Prop({ default: null }) public parentId: string; //伝票キー
  @Prop({ default: false }) public isAdmin: boolean; //管理サイトの添付ファイル取得
  public items: any[] = new Array(0); //リスト
  public selectedItem: any = null; //リスト選択中の項目
  public showUpload: boolean = false;
  public showDescription: boolean = false;
  public description: string = '';
  public tag : string = null;

  //IControl～親Editorから呼び出される
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public isLoading :boolean = false;
  public created() {
    //親Editorに登録する=>編集可否判定を優先してeditorのバインドを無効化
    // if (this.editor != null) this.editor.addControl(this);

  }
  mounted(){
    this.onParentIdChanged();
  }

  @Watch('parentId') 
  @Watch('isAdmin')   
  public onParentIdChanged(){
    const query = new Common.UploadFileQuery();
    query.parentKey = this.parentKey;
    query.parentId = this.parentId;
    query.isAdmin = this.isAdmin;
    this.isLoading = true;
    this.$api.execute(query)
      .then((data: Common.UploadFile[]) => {
        this.isLoading = false;
        this.items = data;
      });
  }

  public get Grid(): Components.Grid {
    return this.$refs.listBox as Components.Grid;
  }

  public onSelected(index: number) {
    this.selectedItem = this.items[index];
  }

  //***********   要実装箇所 *************/

  public onUpload() {
    if(this.$refs.file != null) (this.$refs.file as any).value = '';
    this.description = '';
    this.showUpload = true;
  }

  public onDescription(index: number) {
    this.onSelected(index);
    const obj = this.selectedItem as Common.UploadFile;
    this.description = obj.description;
    this.tag = obj.tag;
    this.showDescription = true;
  }

  public onAdd() {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) return;
    const size = Array.from(obj).reduce((sum, file) => sum + file.size, 0);
    // lambda実行の場合最大サイズを4.4MBとする
    if(this.$api.license.isLambda == true && size > this.$api.fileMaxSizeByte){
      this.$api.modal.show('', String.format("インポートやファイル添付で使用できるファイルサイズは{0}MBまでです。ファイルサイズを減らして再度お試しください。", this.$api.fileMaxSizeMB), true, null);      
      return;
    }
    const query = new Common.UploadFileUploadQuery();
    query.parentKey = this.parentKey;
    query.parentId = this.parentId;
    query.description = this.description;
    query.tag = this.tag ? this.tag: null;
    query.uploadPIC =  this.$api.auth.userId;
    for (var i = 0; i < obj.length; i++) {
      let file = obj[i];
      query.timestamps += new Date(file.lastModified).toISOString() + ',';
    }

    this.$api.upload(query, obj)
    .then(response => {
        (response as any[]).forEach(obj=> this.$set(this.items, this.items.length,obj))
    }
    );

  }

  public onEdit() {
    const obj = this.selectedItem as Common.UploadFile;
    obj.description = this.description;
    obj.tag = this.tag ? this.tag: null;
    this.$api.update(obj)
    .then(response => {
      (response as any[]).forEach(obj => this.$set(this.items, this.items.length,obj))
    }
    );
  }

  public onDelete() {
    var checkedItems = this.items.filter((obj, index) => (this.$refs.listBox as Components.Grid).checked[index]);
    if(checkedItems.length == 0){
      this.$api.modal.show('', '削除したいファイルを選択して下さい。', true, null);      
      return;
    }
    this.$api.removeFiles(checkedItems)
    .then(response=>{      
      this.onParentIdChanged();
    });

  }

  public onDownload(index: number) {
    this.onSelected(index);
    const query = new Common.UploadFileDownloadQuery();
    query.uploadFile = this.selectedItem;
    this.$api.download(query);
  }

  //***********   要実装箇所(終わり) *************/
}
</script>

<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_listFiles {
  @extend .cx_vertical_fill;
  // padding-bottom: 40px;
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;

  overflow-y:unset;
  width: 100%;
  .cx_listFiles_list {
    @extend .cx_vertical_fill;
    // padding-left: 20px;


    .cx_listFiles_header {
      display: flex;
      margin: 0 0 5px 0;
      align-items:flex-end;
      .cx_listFiles_list_buttons {
        flex: 1;

        display: flex;
        justify-content: flex-end;

        button {
          font-size: 12px;
          margin: 0px 0px 0px 5px;
          padding: 4px 8px 4px 6px;
        }
      }
    }
  }
}
.cx_listFiles_detail{
  button {
        font-size: 11px;
        padding: 1px 7px 1px 7px;
        margin : 3px 5px 1px 0px;
        border-radius: 10px;
        font-weight: 500;
        // background-color : green;
        // border-color: green;
    }
}
</style>

